// NPM
import * as React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

// Components
import Layout from "src/layouts/fr"
import DegreeHub from "src/components/pages/DegreeHub/DegreeHub"

const DegreeHubPageFr = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `degreeHubPage.sections`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.degreeHubPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <DegreeHub sections={sections} />
    </Layout>
  )
}

export default DegreeHubPageFr

export const query = graphql`
  query DegreeHubPageFrQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "fr" }) {
      ...topNavContent
    }

    degreeHubPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    bottomNav: strapiBottomNav(locale: { eq: "fr" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
